import { Injectable, inject } from '@angular/core'
import { contract } from '@ftr/annotations-contracts/v2'
import { API_CONFIGURATION, FullApiClientConfiguration } from '@ftr/api-shared'
import { Region } from '@ftr/contracts/type/court'
import { AnnotationsApiClientFactoryBase } from './annotations-api-client.factory.base'
import { AnnotationsApiClientV2 } from './types'

/**
 * Create a client service for ftr-annotations v2 for a given region
 */
@Injectable({
  providedIn: 'root',
})
export class AnnotationsApiClientFactoryV2 extends AnnotationsApiClientFactoryBase {
  private readonly config = inject<FullApiClientConfiguration>(API_CONFIGURATION)

  build(region: Region): AnnotationsApiClientV2 {
    const baseUrl = this.config.annotationsApi.endpointMap[region]
    return this.buildClient(baseUrl, contract)
  }
}
